function blocks() {
    if ( !! $j('.map-block, .siteplan-wrapper').length )  {
		$j('.map-block>.activate, .siteplan-wrapper>.activate').click(function(){
			var el = $j(this);
			el.fadeOut(300);
		});
	}
}
